import esriConfig from "@arcgis/core/config.js";
esriConfig.assetsPath = "./assets";

import '@arcgis/core/assets/esri/themes/light/main.css';
import "@esri/calcite-components/dist/calcite/calcite.css";

import './styles.scss';

import { init } from './main'

init()